import React from "react";
import { ReactComponent as MosquitoIconSvg } from "../../assets/icons/MosquitoVector.svg";
import ArchiveBoxIcon from "@heroicons/react/24/outline/ArchiveBoxIcon";
import "./index.css";

interface DeviceTableRecord {
  key: string;
  deviceName: string;
  location: string;
  address: string;
  coordinates: string;
  wifiConnection: string;
  status: "Online" | "Offline";
  hasMaintenanceAlert: boolean;
  hasDetectionAlert: boolean;
}

const AlertCell: React.FC<{ record: DeviceTableRecord }> = ({ record }) => (
  <div className="flex justify-end pr-4 space-x-2">
    {record.hasMaintenanceAlert && (
      <ArchiveBoxIcon
        className="w-6 h-6 text-[#F97316]"
        title="Maintenance Alert"
      />
    )}
    {record.hasDetectionAlert && (
      <MosquitoIconSvg
        width={24}
        height={24}
        fill="#F97316"
        className="opacity-80"
      />
    )}
  </div>
);

export default AlertCell;
